module.exports = __webpack_public_path__ + "img/logo.0046e19f.png";